import React from 'react';
import Reflux from 'reflux';
import PureRenderMixin from 'react-pure-render/mixin';
import { Row, Col } from 'bootstrap';
import CueClock from 'main/components/show/cuesheet/cueClock.jsx';
import EventClock from 'shared/components/event/clock.jsx';

import CuesheetResponsiveStore from 'flux/stores/cuesheet/CuesheetResponsiveStore';
import UserSessionStore from 'flux/stores/UserSessionStore';
import EventViewStore from 'flux/stores/EventViewStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import RouteActions from 'flux/actions/RouteActions';
import CuesheetCueClockStore from 'flux/stores/cuesheet/CuesheetCueClockStore';

/**
 * Cuesheet (responsive) Header
 *
 */
export default React.createClass({
  displayName: 'CuesheetHeader',

  mixins: [
    PureRenderMixin,
    Reflux.connectFilter(CuesheetResponsiveStore, 'displayMode', (state) =>
      state.get('displayMode'),
    ),
    Reflux.connectFilter(
      CuesheetCueClockStore,
      'toggleFullScreenClock',
      (state) => state.get('toggleFullScreenClock'),
    ),
    Reflux.connect(EventViewStore, 'event'),
    Reflux.connectFilter(CuesheetStore, 'show', (state) =>
      state.getIn(['show']),
    ),
    Reflux.connect(UserSessionStore, 'user'),
  ],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    let { show, event, toggleFullScreenClock } = this.state;
    const { params } = this.context.router.state;

    const { teamId } = params;
    const eventTitle = event.get('title');

    let fullPageCueClock = (
      <CueClock fullscreen={toggleFullScreenClock} hideDescription />
    );

    if (!toggleFullScreenClock) fullPageCueClock = null;

    if (!show) return null;

    let showTitle = show.get('title'),
      displayClocks = show.get('displayClocks');

    let clocksNode = null;

    if (displayClocks) {
      clocksNode = (
        <Col
          className="csr-clocks"
          lg={12}
          md={16}
          sm={14}
          xsOffset={4}
          xs={16}
          lgOffset={6}
          mdOffset={4}
          smOffset={5}
        >
          <CueClock />
          <EventClock />
        </Col>
      );
    }

    let backActionHandler =
      event && event.get('globalTemplateContainer')
        ? RouteActions.goToTeamTemplates
        : RouteActions.goToEvent;

    return (
      <div>
        {fullPageCueClock}
        <header className="container-fluid csr-header csr-header-light">
          <Row>
            <Col lg={4} md={4} sm={3} xs={3}>
              <div
                className="cs-header-hamburger"
                onClick={() =>
                  backActionHandler &&
                  backActionHandler({
                    teamId: teamId,
                    eventId: event.get('_id'),
                  })
                }
              >
                <div className="cs-header-back-button">
                  <span className="fa fa-3x fa-arrow-left" />
                  Back
                </div>
              </div>
            </Col>
            <Col
              className="csr-show-title-wrapper"
              lg={16}
              md={16}
              sm={16}
              xs={16}
              xsOffset={1}
              smOffset={1}
              mdOffset={0}
            >
              <h5 className="show-title">{showTitle}</h5>
              <h5 className="event-title">{eventTitle}</h5>
            </Col>
            {clocksNode}
          </Row>
        </header>
      </div>
    );
  },
});
